import React, { useState } from 'react';
import merge from 'lodash/merge';
import { TextField, Button } from '@/components';
import useLocation from '@/hooks/useLocation';
import useMixpanel from '@/hooks/useMixpanel';
import t from '@/utils/Language/SearchResourceForm-translations';
import { searchHelpers } from '@/utils/helpers';
import { Col, Form, Row } from 'react-bootstrap';
import classes from './SearchResourceForm.module.scss';

const SearchResourceForm = ({ buttonSettings = {}, overrideClasses = {}, searchFieldSettings = {}, newTab, project, ...props }) => {
  const [searchText, setSearchText] = useState('');
  const { locationContext } = useLocation();
  const combinedClasses = merge(classes, overrideClasses);
  const { track } = useMixpanel(project === 'familyResourceFinder' ? 'MSI_Family_Resource_Finder' : '');

  const browseResource = () => {
    track('Browse resources');
    if (newTab) {
      const anchor = document.createElement('a');
      anchor.href = `/search`;
      anchor.target = '_blank';
      anchor.click();
    } else {
      window.location.href = `/search`;
    }
  };

  const handleSearchTextChange = (value) => {
    setSearchText(value);
  };

  const doSearch = (e) => {
    track('search', {
      query: searchText
    });

    e?.preventDefault();
    if (newTab) {
      const anchor = document.createElement('a');
      anchor.href = searchHelpers.searchTextLink(searchText, { lat: locationContext.getLocation()?.lat, lng: locationContext.getLocation()?.lng });
      anchor.target = '_blank';
      anchor.click();
    } else {
      window.location.href = searchHelpers.searchTextLink(searchText, {
        lat: locationContext.getLocation()?.lat,
        lng: locationContext.getLocation()?.lng
      });
    }
  };

  const onClear = (value) => {
    setSearchText('');
  };

  const searchTextField = merge(
    {
      placeholder: t('Search for resources'),
      type: 'default',
      onClear: onClear,
      id: 'searchInput',
      additionalClasses: combinedClasses.searchField,
      clear: false,
      icon: {
        position: 'right',
        style: 'fas',
        font: 'search',
        additionalIconClass: combinedClasses.searchIcon,
        onClick: doSearch
      }
    },
    searchFieldSettings
  );

  const buttonProps = merge(
    {
      type: 'primary',
      shape: 'rounded',
      onButtonClick: () => browseResource(),
      additionalClasses: combinedClasses.browseButton,
      styles: { width: 'full' },
      icon: {
        style: 'fas',
        font: 'table-cells',
        position: 'left',
        color: 'white'
      },
      text: t('Browse Resources')
    },
    buttonSettings
  );

  return (
    <>
      <div className={combinedClasses.container}>
        <div className={combinedClasses.title}>
          <p>{t('Are you looking for other resources?')}</p>
        </div>
        <div className={combinedClasses.subtitle}>
          <p
            dangerouslySetInnerHTML={{
              __html: t(
                'Search from thousands of community resources on One Degree below. Search for services like food pantries, tax preparation or dental health.'
              )
            }}
          ></p>
        </div>
        <div className={combinedClasses.formContainer}>
          <Form className="form-inline" onSubmit={doSearch}>
            <Form.Group controlId="formBasicName">
              <Row>
                <Col>
                  <TextField {...searchTextField} value={`${searchText}`} onChange={handleSearchTextChange} />
                </Col>
              </Row>
              <Row>
                <Col>
                  <span className={combinedClasses.or}>{t('OR')}</span>
                </Col>
              </Row>
            </Form.Group>
          </Form>
          <Row>
            <Col>
              <Button {...buttonProps} />
            </Col>
          </Row>
        </div>
      </div>
    </>
  );
};

export default SearchResourceForm;
